import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { AgendamentoSolicitacaoItem } from '@/types/_'
import { ISolicitacaoChatMessage, SolicitacaoChatMessageTypeEnum } from '@/types/interfaces/solicitacao-chat/solicitacao-chat-message.interface'
import { getModule } from 'vuex-module-decorators'
import { Component, Vue } from 'vue-property-decorator'
import ChatxModule from '@/components/chatx/chatx/chatx.module'
import { SolicitacaoChatAreaResponsavelEnum } from '@/types/interfaces/solicitacao-chat/solicitacao-chat-area-responsavel.enum'
import EventBus from '@/plugins/EventBus'
import ChatStore from '@/components/Chat/Store/ChatStore'
import BackofficeDataAgendamentoStore from '@/components/Backoffice/Store/BackofficeDataAgendamentoStore'
import BackofficeModalChatStore from '../store/backoffice-modal-chat-store'
import BackofficeChatStore from '../store/backoffice-chat-store'

@Component({
  components: ChatxModule.exportComponents,
})
export default class ComponentFilter extends Vue {
  canShowRightPanel = false

  // Loading flags
  admitChatLoading = false
  changeAreaLoading = false
  finishChatLoading = false
  seeMoreLoading = false
  roomReservationModalLoading: boolean = false

  mounted() {
    // Check can show right panel when starts based in screen width
    if (window.screen.availWidth > 600) {
      this.canShowRightPanel = true
    }
  }

  sendAttachment(data: File) {
    this.chatStore.sendAttachment(data)
  }

  get attachmentLoading() {
    return this.chatStore.attachmentLoading
  }

  set attachmentLoading(value: boolean) {
    this.chatStore.setAttachmentLoading(value)
  }

  send(value: string) {
    const message = {
      tipo: SolicitacaoChatMessageTypeEnum.texto,
      texto: value,
    } as ISolicitacaoChatMessage

    this.chatStore.sendMessage(message)
  }

  async admitChat() {
    this.admitChatLoading = true
    await this.chatStore.admitChat()
    this.admitChatLoading = false
    this.ga('backoffice-chat', 'assumir-chat')
  }

  async changeAreaToSchedule() {
    this.changeAreaLoading = true
    await this.chatStore.changeChatArea(SolicitacaoChatAreaResponsavelEnum.agendamento)
    this.changeAreaLoading = false
    this.close()
    this.ga('backoffice-chat', 'encaminhar-para-agendamento')
  }

  async openUpdateRoomReservationModal() {
    try {
      this.roomReservationModalLoading = true

      this.getBackofficeGlobalStore.setBackofficeArea('agendamento')

      const { solicitationId: surgerySolicitationId } = this.chatStore

      await this.getBackofficeGlobalStore.getSolicitacaoById(surgerySolicitationId)

      const surgeryItem = {
        ...this.getBackofficeGlobalStore.solicitacao,
      } as unknown as AgendamentoSolicitacaoItem

      if (this.getBackofficeGlobalStore.componentToConfirmReservation === 'BackofficeConfirmarReservaSala') {
        const blockSurgeryRequest = await this.getBackofficeGlobalStore.bloquearSolicitacao(surgeryItem.id)

        if (blockSurgeryRequest.success) {
          await this.defaultChatStore.getDataAgendamento(surgeryItem.id)
          await this.getBackofficeGlobalStore.getHospitalTemplate(surgeryItem.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'reservaDeSala', value: true })
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: blockSurgeryRequest.message || 'Não foi possível carregar os dados da reserva', icon: 'warning', color: '#C62828' })
        }
      } else {
        await this.defaultChatStore.getDataAgendamento(surgeryItem.id)
        await this.getBackofficeDataAgendamentoStore.setAgendamentoItem({ ...surgeryItem })
        this.getBackofficeDataAgendamentoStore.setModal({ name: 'confirmarDataAgendamento', value: true })
      }

      this.ga('backoffice-agendamento', 'confirmar-data')
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível carregar os dados da reserva', icon: 'warning', color: '#C62828' })
    } finally {
      this.roomReservationModalLoading = false
    }
  }

  async changeAreaToAuthorization() {
    this.changeAreaLoading = true
    await this.chatStore.changeChatArea(SolicitacaoChatAreaResponsavelEnum.autorizacao)
    this.changeAreaLoading = false
    this.close()
    this.ga('backoffice-chat', 'encaminhar-para-autorizacao')
  }

  async finishChat() {
    this.finishChatLoading = true
    await this.chatStore.finishChat()
    this.finishChatLoading = false
    this.close()
    this.ga('backoffice-chat', 'finalizar-chat')
  }

  async close() {
    await this.chatStore.closeChatModal()
    this.backofficeChatStore.loadChats()
  }

  async seeMore() {
    this.seeMoreLoading = true
    const { solicitationId } = this.chatStore
    const hospitalId = this.chatStore.solicitation.hospitalId!

    this.getBackofficeGlobalStore.setBackofficeArea('agendamento')
    this.$router.push({ name: 'backoffice-surgery-solicitation-details', params: { solicitacaoId: solicitationId } })

    this.ga('backoffice-chat', 'visualizar-solicitacao')
    this.seeMoreLoading = false
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  toggleRightPanel() {
    this.canShowRightPanel = !this.canShowRightPanel
  }

  formatDateForDay(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      let completedDate: string
      if (date.toLocaleDateString() === new Date().toLocaleDateString()) {
        completedDate = 'Hoje'
      } else {
        completedDate = date.toLocaleDateString()
      }

      return `${completedDate} às ${hours}:${minutes}`
    }

    return ''
  }

  getMessageType(data: ISolicitacaoChatMessage) {
    if (data.tipoMensagem) {
      const messageType = data.tipoMensagem.key

      if (
        messageType === SolicitacaoChatMessageTypeEnum.texto
        || messageType === SolicitacaoChatMessageTypeEnum.anexo
      ) {
        return 'message'
      }
    }

    return 'marker'
  }

  getMessageSide(data: ISolicitacaoChatMessage) {
    const loggedUserId = this.$user.profile.sub
    if (data.usuarioId === loggedUserId) {
      return 'right'
    }

    return 'left'
  }

  getCanShowFooter(data: ISolicitacaoChatMessage) {
    const loggedUserId = this.$user.profile.sub
    const messageType = this.getMessageType(data)

    if (
      data.usuarioId === loggedUserId
      && messageType !== 'marker'
    ) {
      return true
    }

    return false
  }

  getSenderName(data: ISolicitacaoChatMessage) {
    const loggedUserId = this.$user.profile.sub
    const messageType = this.getMessageType(data)

    if (
      data.usuarioId !== loggedUserId
      && messageType !== 'marker'
    ) {
      return data.usuarioNome
    }

    return ''
  }

  get chatStore() {
    return getModule(BackofficeModalChatStore, this.$store)
  }

  get defaultChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get backofficeChatStore() {
    return getModule(BackofficeChatStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeDataAgendamentoStore() {
    return getModule(BackofficeDataAgendamentoStore, this.$store)
  }
}
